import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";
import BottomNavBar from "../BottomNavBar";

export default function Layout() {
  return (
    <>
      <Header logoSrc="/images/logo.svg" variant="cs_heading_color" />
      <Outlet />
      <BottomNavBar />
      <Footer />
    </>
  );
}
